import { Alert } from '@mui/material'
import { format } from 'date-fns'

import { DRIVER_APP_FULFILMENT_RELIABLE_FROM_DATE } from 'components/reports/Metrics/constants/DriverAppFulfilment'
import { useGetDriverAppFulfilmentReliableFromDateQuery } from 'generated/graphql'

interface Props {
  start: Date | null
}

// Shown whenever the selected period reaches back before posting dates were recorded. This page
// filters on the same Booking.SharedWithNetworkAt as the Driver App vs CX Fulfilment tab, so it
// shares that tab's "posting dates reliable from" app setting (Settings -> Global Variables) and
// fallback constant — the two pages can never disagree about when posting dates became reliable.
export const BidAnalysisHistoryNote = ({ start }: Props) => {
  const { data } = useGetDriverAppFulfilmentReliableFromDateQuery()

  const configured = data?.driverAppFulfilmentReliableFromDate
  const reliableFrom = configured ? new Date(configured) : DRIVER_APP_FULFILMENT_RELIABLE_FROM_DATE

  if (start == null || start >= reliableFrom) {
    return null
  }

  const reliableFromMonth = format(reliableFrom, 'MMMM yyyy')

  return (
    <Alert severity='info'>
      {`Jobs posted before ${reliableFromMonth} may be under-represented. Posting dates were not ` +
        'recorded before this point and can only be recovered for some historical jobs. As a ' +
        'result, bid counts and response times for earlier periods may be incomplete.'}
    </Alert>
  )
}
